import { Col } from "react-bootstrap";
import { useEffect, useState } from "react";

const contentBlocks = [
    {
        title: "👨‍💻 Who Am I",
        text: `I'm Wilbroad Francis Mark — a passionate software developer from Tanzania. 
I currently intern at the [e-Government Authority (eGA)](https://www.ega.go.tz/), and work as a freelance software developer, delivering real-world solutions across web and mobile platforms.`,
    },
    {
        title: "🎓 Education",
        text: `Bachelor of Science in Software Engineering – [University of Dodoma (UDOM)](https://www.udom.ac.tz/). 
I’ve built a strong foundation in software design, distributed systems, and application development.`,
    },
    {
        title: "🛠️ Tech Stack",
        text: `Backend: Laravel, Spring Boot, Django\nFrontend: Angular, ReactJS, Vue.js, Next.js\nMobile: Flutter\nDatabases: MySQL, PostgreSQL, MongoDB\nDevOps: Docker, GitHub Actions, CI/CD Pipelines`,
    },
    {
        title: "🚀 Current Project – Operon",
        text: `[Operon](https://operon.ih-africa.com/) is a project management system for government institutions. It helps manage workflows, improve transparency, and digitize project tracking across departments.`,
    },
    {
        title: "🎯 Goals",
        text: `I'm working toward mastering Machine Learning and Deep Learning to integrate intelligent systems into mobile and web applications.`,
    },
];

const parseMarkdownLinks = (text: string) => {
    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    const parts: (string | JSX.Element)[] = [];

    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
        const [fullMatch, linkText, url] = match;
        const start = match.index;

        if (start > lastIndex) {
            parts.push(text.slice(lastIndex, start));
        }

        parts.push(
            <a
                key={url + start}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-info text-decoration-none"
            >
                {linkText}
            </a>
        );

        lastIndex = start + fullMatch.length;
    }

    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return parts;
};

const EducationTimeline = () => {
    const [visibleItems, setVisibleItems] = useState(1);

    useEffect(() => {
        const timer = setInterval(() => {
            setVisibleItems((prev) => (prev < contentBlocks.length ? prev + 1 : prev));
        }, 800);

        return () => clearInterval(timer);
    }, []);

    return (
        <Col
            md={12}
            className="text-light px-4 d-flex flex-column justify-content-center"
            style={{ minHeight: "100vh", overflowY: "auto" }}
        >
            {contentBlocks.slice(0, visibleItems).map((block, index) => (
                <div key={index} className="mb-4">
                    <h4 className="fw-bold text-warning">{block.title}</h4>
                    <p className="text-light" style={{ whiteSpace: "pre-line" }}>
                        {parseMarkdownLinks(block.text)}
                    </p>
                </div>
            ))}
        </Col>
    );
};

export default EducationTimeline;
